import cn from "classnames"
import { ReactNode } from "react"

import style from "modules/Call/components/ControlButtonWrapper/style.module.scss"

interface Props {
    className?: string
    children?: ReactNode
    isRounded?: boolean
    isRed?: boolean
    isLocked?: boolean
    isHovered?: boolean
}

export function ControlButtonWrapper({
    className,
    children,
    isRounded,
    isRed,
    isLocked,
    isHovered,
}: Props) {
    return (
        <div
            className={cn(style.container, className, {
                [style.isRounded]: isRounded,
                [style.isRed]: isRed,
                [style.isLocked]: isLocked,
                [style.isHovered]: isHovered,
            })}
        >
            {children}
        </div>
    )
}
